import PropTypes from 'prop-types';
import React from 'react';
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import { Field, useField } from 'react-final-form';
import RadioAdapter from './RadioAdapter.jsx';

RadioOptionsField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
};

function RadioOptionsField({
  id,
  label,
  name,
  options,
  customClass,
  disabled,
}) {
  const { meta } = useField(name, {
    subscription: {
      error: true,
      submitError: true,
      touched: true,
    },
  });
  const hasError = meta.touched && (meta.error || meta.submitError);

  return (
    <FormGroup
      controlId={id}
      validationState={hasError ? 'error' : null}
      className={customClass}
    >
      {label ? <ControlLabel>{label}</ControlLabel> : null}
      {options.map((option) => {
        return (
          <React.Fragment key={option.value}>
            <Field
              name={name}
              component={RadioAdapter}
              label={option.label}
              type="radio"
              value={option.value}
              disabled={disabled}
              archived={option.archived}
            />
            {option.description && (
              <span
                className="text-muted m-l-32"
                style={{ display: 'block', marginTop: '-10px' }}
              >
                {option.description}
              </span>
            )}
          </React.Fragment>
        );
      })}
      {hasError && <HelpBlock>{meta.error || meta.submitError}</HelpBlock>}
    </FormGroup>
  );
}

export default RadioOptionsField;
